import { conditionalHooksFactory } from '@atlaskit/platform-feature-flags-react';
import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import type { SyncedBlockPlugin } from '@atlaskit/editor-plugin-synced-block';

import { expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';

export type EditorPresetAPI = PublicPluginAPI<[SyncedBlockPlugin]> | null | undefined;

export const useSharedSyncBlockState = conditionalHooksFactory(
	() =>
		// eslint-disable-next-line confluence-feature-gating/no-preconditioning
		fg('platform_synced_block_patch_5') && expValEquals('platform_synced_block', 'isEnabled', true),
	(api: EditorPresetAPI) => {
		const hasUnsavedBodiedSyncBlockChanges =
			useSharedPluginStateSelector(api, 'syncedBlock.hasUnsavedBodiedSyncBlockChanges', {
				disabled: !api,
			}) ?? false;
		return { hasUnsavedBodiedSyncBlockChanges };
	},
	(_api: EditorPresetAPI) => {
		return {
			hasUnsavedBodiedSyncBlockChanges: false,
		};
	},
);
